// src/theme/escalaPagina.js

/**
 * Medidas comuns das páginas do plano Laticínio (propriedade, coleta, ações, pontos,
 * colostro). A barra de cima já mostra o nome da página, então o título grande só vale
 * em tela grande; no notebook (abaixo de 1536 px) ele e a margem externa encolhem.
 * Somado à densidade de notebook (index.css), mantém a proporção em telas de 14".
 */
export const TITULO_PAGINA = {
    fontSize: { xs: '1.6rem', md: '1.85rem', xl: '2.125rem' },
    lineHeight: 1.2,
};

/** Margem lateral da página: 32 px só em tela grande. */
export const MARGEM_LATERAL = { xs: 2, sm: 3, xl: 4 };
